/**
 * Top-5 EVM chains we surface in the wallet, named to match LeoKit's
 * canonical chain identifiers (uppercase). These ids are what we send
 * in the /balances request body and what we match against `chain` in
 * the response rows.
 *
 * `nativeSymbol` is purely informational — actual ticker labels come
 * back from LeoKit per-row in `token_symbol`. `color` is used for the
 * small chain dot in the holdings list.
 */
export const EVM_CHAINS = [
  { id: "ETH",     name: "Ethereum",  nativeSymbol: "ETH",  color: "#627EEA" },
  { id: "BASE",    name: "Base",      nativeSymbol: "ETH",  color: "#0052FF" },
  { id: "ARB",     name: "Arbitrum",  nativeSymbol: "ETH",  color: "#28A0F0" },
  { id: "OP",      name: "Optimism",  nativeSymbol: "ETH",  color: "#FF0420" },
  { id: "POLYGON", name: "Polygon",   nativeSymbol: "POL",  color: "#8247E5" },
] as const;

export type EvmChainId = (typeof EVM_CHAINS)[number]["id"];
